import { useEffect, useRef } from 'react';

// Declarative setInterval: the callback can change every render without
// resetting the timer, and passing `delay === null` pauses it. Web equivalent of
// the mobile app/src/hooks/useInterval.js.
export default function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback so the running interval always calls current
  // props/state without being torn down and recreated.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval; a null delay leaves it paused.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
